import { useDispatch } from 'react-redux';
import { showModal } from 'src/old/actions/modal/modalActions';
import { Typography, Avatar, Grid, Tooltip } from '@mui/material';
import HelperIcon from 'src/shared/components/HelperIcon';
import { MODAL_TYPES } from 'src/shared/components/Modals';
import { useStyles } from './styles';
import { type StatisticDataType } from './types';

const FeatureStatistics = ({ headline, value, icon, explanation }: StatisticDataType) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const modalProps = {
    header: explanation?.title,
    content: explanation?.description
  };
  const modalType = MODAL_TYPES.INFO;

  const openExplanationDialog = () => {
    showModal(modalProps, modalType)(dispatch);
  };

  return (
    <div className={classes.wrapper}>
      <Grid className={classes.containerWrapper} container>
        <div>
          <Avatar className={classes.avatar}>{icon}</Avatar>
        </div>

        <div className={classes.headlineWrapper}>
          <Tooltip title={headline} enterDelay={500}>
            <Typography className={classes.headline} component="h3" gutterBottom variant="overline">
              <div>{headline}</div>
              {explanation && <HelperIcon action={openExplanationDialog} />}
            </Typography>
          </Tooltip>
        </div>
      </Grid>
      <Grid item className={classes.valueWrapper}>
        <Tooltip title={value?.toString()} enterDelay={500}>
          <Typography className={classes.value} variant="h2">
            {value ?? '-'}
          </Typography>
        </Tooltip>
      </Grid>
    </div>
  );
};

export default FeatureStatistics;
